import {
  CardInfo,
  getAllOverflowItems,
  Handlers,
  ItemKeys,
  TrackUe,
} from './overflow-menu-items';

export const getHighlightsOverflowItems = (
  cardInfo: CardInfo,
  handlers: Handlers,
  trackUe: TrackUe, // TODO: TMON-1006: Use Gamma's trackUE function
) => {
  const itemKeys: ItemKeys = {
    subscribe: true,
    unsubscribe: true,
    joinCard: true,
    leaveCard: true,
  };

  const tracking = {
    getPrepObj: () => '',
    getIndObj: () => '',
    trackUe,
    getMethod: (itemName: string) =>
      `by clicking ${itemName} menu item on highlights card`,
  };

  const overflowItems = getAllOverflowItems(cardInfo, handlers, tracking);

  return overflowItems.filter((item) => item.shouldShow && itemKeys[item.key]);
};



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/util/highlight.ts